import { render, staticRenderFns } from "./ContactPage.html?vue&type=template&id=6f7404f2&scoped=true&"
import script from "./ContactPage.js?vue&type=script&lang=js&"
export * from "./ContactPage.js?vue&type=script&lang=js&"
import style0 from "./ContactPage.scss?vue&type=style&index=0&id=6f7404f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7404f2",
  null
  
)

export default component.exports